export default __webpack_public_path__ + "static/media/physical_activity.0af9f641.svg";